<div class="container-fluid padding-top padding-bottom">
  <md-card *ngIf="componentSettings; else loading">
    <div class="row">
      <div class="col-md-12">
        <button class="btn btn-primary"
                color="primary"
                (click)="goBack()">Go Back</button>
      </div>
      <div class="col-md-12 text-center">
        <h1>{{ clientData?.name}}</h1>
      </div>
      <div class="col-md-12">
        <h2>Component Data Settings</h2>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <h5>Features Component</h5>
      </div>
      <div class="col-md-6">
        <h5>Reserve Success</h5>
      </div>

      <div class="col-md-6">
        <h3>SVG Type</h3>
        <p-dropdown [filter]="true"
                    [(ngModel)]="componentSettings.svgType"
                    (onChange)="saveComponentSettings()"
                    [options]="svgOptions"></p-dropdown>
        <p-dataTable [value]="componentSettings.features"
                     [(selection)]="selectedFeature"
                     (onEditComplete)="saveFeature($event)"
                     [responsive]="true"
                     [editable]="true"
                     class="text-center">
          <!-- <p-dataTable [value]="componentSettings.features" selectionMode="single" [(selection)]="selectedFeature" (onRowSelect)="onFeatureRowSelect($event)" -->
          <!-- [responsive]="true" [editable]="true" class="text-center"> -->
          <p-header>Features Component</p-header>
          <p-column field="iconUrl"
                    header="Icon URL"
                    [editable]="true">
            <ng-template let-col
                         let-car="rowData"
                         pTemplate="body">
              <span *ngIf="clientData.homePageFeaturesComponent !== 'svg'; else svgIcon"><img class="facility-logo"
                     [src]="car[col.field]"
                     alt=""></span>
              <ng-template #svgIcon>
                <div [innerHtml]="car[col.field] | keepHtml"></div>
              </ng-template>
            </ng-template>
            <ng-template let-col
                         let-car="rowData"
                         pTemplate="editor">
              <input *ngIf="clientData.homePageFeaturesComponent !== 'svg' ; else svgIconSelect"
                     pInputText
                     id="iconUrl"
                     (change)="saveFeature({data: car})"
                     [(ngModel)]="car[col.field]" />
              <ng-template #svgIconSelect>
                <p-dropdown [filter]="true"
                            [(ngModel)]="car[col.field]"
                            (onChange)="saveFeature({data: car})"
                            [options]="iconOptions"></p-dropdown>
              </ng-template>
            </ng-template>
          </p-column>
          <p-column field="name"
                    header="Name"
                    [editable]="true"></p-column>
          <p-column field="title"
                    header="Title/Alt"
                    [editable]="true"></p-column>
          <p-column field="description"
                    header="Description"
                    [editable]="true"></p-column>
          <p-column field="delete"
                    header="Delete">
            <ng-template let-col
                         let-car="rowData"
                         pTemplate="body">
              <button type="button"
                      class="btn btn-primary"
                      color="primary"
                      icon="fa-close"
                      (click)="deleteFeature(car)"
                      label="Delete"><i class="fa fa-close"
                   aria-hidden="true"></i> Delete</button>
            </ng-template>
          </p-column>
          <p-footer>
            <div class="ui-helper-clearfix"
                 style="width:100%">
              <button type="button"
                      class="btn btn-primary"
                      color="primary"
                      style="float:left"
                      (click)="showFeatureDialogToAdd()">
                <i class="fa fa-plus"
                   aria-hidden="true"></i> Add
              </button>
            </div>
          </p-footer>
        </p-dataTable>
      </div>
      <div class="col-md-6">
        <label for="success">Success Message</label>
        <input class="full-width"
               pInputText
               id="success"
               [(ngModel)]="componentSettings?.reserveSuccess.success" />
        <div class="sm-padding-top"></div>
        <label class="sm-padding-top"
               for="line1">Line 1</label>
        <input class="full-width"
               pInputText
               id="line1"
               [(ngModel)]="componentSettings?.reserveSuccess.line1" />
        <div class="sm-padding-top"></div>
        <label class="sm-padding-top"
               for="line2">Line 2</label>
        <input class="full-width"
               pInputText
               id="line2"
               [(ngModel)]="componentSettings?.reserveSuccess.line2" />
        <h5>Rent Success</h5>
        <label for="success1">Success Message</label>
        <input class="full-width"
               pInputText
               id="success1"
               [(ngModel)]="componentSettings?.rentSuccess.success" />
        <div class="sm-padding-top"></div>
        <label class="sm-padding-top"
               for="line11">Line 1</label>
        <input class="full-width"
               pInputText
               id="line11"
               [(ngModel)]="componentSettings?.rentSuccess.line1" />
        <md-slide-toggle [(ngModel)]="componentSettings?.rentSuccess.line1Bold">Make it bold</md-slide-toggle>
        <div class="sm-padding-top"></div>
        <label class="sm-padding-top"
               for="line21">Line 2</label>
        <input class="full-width"
               pInputText
               id="line21"
               [(ngModel)]="componentSettings?.rentSuccess.line2" />
        <md-slide-toggle [(ngModel)]="componentSettings?.rentSuccess.line2Bold">Make it bold</md-slide-toggle>
      </div>
    </div>

    <p-dialog header="Features Component Details"
              [(visible)]="displayFeatureDialog"
              [responsive]="true"
              showEffect="fade"
              [modal]="true"
              [positionTop]="100"
              [dismissableMask]="true">
      <div class="ui-grid ui-grid-responsive ui-fluid"
           *ngIf="feature">
        <div class="ui-grid-row sm-padding-top">
          <div class="ui-grid-col-4">
            <label for="name">Name</label>
          </div>
          <div class="ui-grid-col-8">
            <input pInputText
                   id="name"
                   [(ngModel)]="feature.name" />
          </div>
        </div>
        <div class="ui-grid-row sm-padding-top">
          <div class="ui-grid-col-4">
            <label for="iconUrl">Icon URL</label>
          </div>
          <div class="ui-grid-col-8">
            <input *ngIf="clientData.homePageFeaturesComponent !== 'svg'; else svgIconSelect2"
                   pInputText
                   id="iconUrl"
                   [(ngModel)]="feature.iconUrl" />
            <ng-template #svgIconSelect2>
              <p-dropdown [filter]="true"
                          [(ngModel)]="feature.iconUrl"
                          [options]="iconOptions"></p-dropdown>
            </ng-template>
          </div>
        </div>
        <div class="ui-grid-row sm-padding-top">
          <div class="ui-grid-col-4">
            <label for="iconUrl">Title/Alt</label>
          </div>
          <div class="ui-grid-col-8">
            <input pInputText
                   id="alt1"
                   [(ngModel)]="feature.alt" />
          </div>
        </div>
      </div>
      <p-footer>
        <div class="ui-dialog-buttonpane ui-helper-clearfix">
          <button class="btn btn-default"
                  *ngIf="!newFeature"
                  style="float:left"
                  (click)="deleteFeature()"><i class="fa fa-close"
               aria-hidden="true"></i> Delete</button>
          <button class="btn btn-primary"
                  color="primary"
                  (click)="saveFeature()"><i class="fa fa-check"
               aria-hidden="true"></i> Save</button>
        </div>
      </p-footer>
    </p-dialog>

    <div class="row">
      <div class="col-md-12">
        <h5>Small Primary Icon Bar</h5>
      </div>
      <div class="col-md-8">
        <label for="title">Main Title</label>
        <input *ngIf="clientData.homePageMainIconsComponent == 'v3'"
               class="full-width"
               pInputText
               id="title"
               [(ngModel)]="componentSettings?.smallPrimaryIconBar.title" />
      </div>
      <div class="col-md-8">
        <label for="title1">Title 1</label>
        <input class="full-width"
               pInputText
               id="title1"
               [(ngModel)]="componentSettings?.smallPrimaryIconBar.title1" />
        <label for="icon1url">Title 1 Icon URL</label>
        <input *ngIf="clientData.homePageMainIconsComponent !== 'svg' && clientData.homePageMainIconsComponent !== 'v3'; else svgIconSelectLg1"
               class="full-width"
               pInputText
               #icon1url
               id="icon1url"
               [(ngModel)]="componentSettings?.smallPrimaryIconBar.icon1url" />
        <ng-template #svgIconSelectLg1>
          <p-dropdown [filter]="true"
                      [(ngModel)]="componentSettings?.smallPrimaryIconBar.icon1url"
                      [options]="iconOptions"></p-dropdown>
        </ng-template>
        <label for="card3url">Title 1 Card URL</label>
        <input *ngIf="clientData.homePageMainIconsComponent == 'v3';"
               class="full-width"
               pInputText
               #card1url
               id="card1url"
               [(ngModel)]="componentSettings?.smallPrimaryIconBar.card1url" />
        <label for="text1">Text</label>
        <input class="full-width"
               pInputText
               id="text1"
               [(ngModel)]="componentSettings?.smallPrimaryIconBar.text1" />
        <label for="backText1"
               *ngIf="clientData.homePageMainIconsComponent !== 'v3'">Back Text</label>
        <input *ngIf="clientData.homePageMainIconsComponent !== 'v3'"
               class="full-width"
               pInputText
               id="backText1"
               [(ngModel)]="componentSettings?.smallPrimaryIconBar.backText1" />
        <label for="seoTitle1">SEO Title</label>
        <input class="full-width"
               pInputText
               id="seoTitle1"
               [(ngModel)]="componentSettings?.smallPrimaryIconBar.seoTitle1" />
        <label for="alt1">Alt 1</label>
        <input class="full-width"
               pInputText
               id="alt1"
               [(ngModel)]="componentSettings?.smallPrimaryIconBar.alt1" />
      </div>
      <div class="col-md-4">
        <img *ngIf="clientData.homePageMainIconsComponent !== 'svg' && clientData.homePageMainIconsComponent !== 'v3'; else showSvg1"
             [src]="componentSettings.smallPrimaryIconBar.icon1url"
             class="icon-image"
             alt="">
        <ng-template #showSvg1>
          <div [innerHtml]="componentSettings.smallPrimaryIconBar.icon1url | keepHtml"></div>
        </ng-template>
      </div>
    </div>
    <hr>
    <div class="row">
      <div class="col-md-8">
        <label for="title2">Title 2</label>
        <input class="full-width"
               pInputText
               id="title2"
               [(ngModel)]="componentSettings?.smallPrimaryIconBar.title2" />
        <label for="icon2url">Title 2 Icon URL</label>
        <input *ngIf="clientData.homePageMainIconsComponent !== 'svg' && clientData.homePageMainIconsComponent !== 'v3'; else svgIconSelectLg2"
               class="full-width"
               pInputText
               #icon2url
               id="icon2url"
               [(ngModel)]="componentSettings?.smallPrimaryIconBar.icon2url" />
        <ng-template #svgIconSelectLg2>
          <p-dropdown [filter]="true"
                      [(ngModel)]="componentSettings?.smallPrimaryIconBar.icon2url"
                      [options]="iconOptions"></p-dropdown>
        </ng-template>
        <label for="card3url">Title 2 Card URL</label>
        <input *ngIf="clientData.homePageMainIconsComponent == 'v3';"
               class="full-width"
               pInputText
               #card2url
               id="card2url"
               [(ngModel)]="componentSettings?.smallPrimaryIconBar.card2url" />
        <label for="text2">Text</label>
        <input class="full-width"
               pInputText
               id="text2"
               [(ngModel)]="componentSettings?.smallPrimaryIconBar.text2" />
        <label for="backText2"
               *ngIf="clientData.homePageMainIconsComponent !== 'v3'">Back Text</label>
        <input *ngIf="clientData.homePageMainIconsComponent !== 'v3'"
               class="full-width"
               pInputText
               id="backText2"
               [(ngModel)]="componentSettings?.smallPrimaryIconBar.backText2" />
        <label for="seoTitle2">SEO Title</label>
        <input class="full-width"
               pInputText
               id="seoTitle2"
               [(ngModel)]="componentSettings?.smallPrimaryIconBar.seoTitle2" />
        <label for="alt2">Alt 2</label>
        <input class="full-width"
               pInputText
               id="alt2"
               [(ngModel)]="componentSettings?.smallPrimaryIconBar.alt2" />
      </div>
      <div class="col-md-4">
        <img *ngIf="clientData.homePageMainIconsComponent !== 'svg' && clientData.homePageMainIconsComponent !== 'v3'; else showSvg2"
             [src]="componentSettings.smallPrimaryIconBar.icon2url"
             class="icon-image"
             alt="">
        <ng-template #showSvg2>
          <div [innerHtml]="componentSettings.smallPrimaryIconBar.icon2url | keepHtml"></div>
        </ng-template>
      </div>
    </div>
    <hr>
    <div class="row">
      <div class="col-md-8">
        <label for="title3">Title 3</label>
        <input class="full-width"
               pInputText
               id="title3"
               [(ngModel)]="componentSettings?.smallPrimaryIconBar.title3" />
        <label for="icon3url">Title 3 Icon URL</label>
        <input *ngIf="clientData.homePageMainIconsComponent !== 'svg' && clientData.homePageMainIconsComponent !== 'v3'; else svgIconSelectLg3"
               class="full-width"
               pInputText
               #icon3url
               id="icon3url"
               [(ngModel)]="componentSettings?.smallPrimaryIconBar.icon3url" />
        <ng-template #svgIconSelectLg3>
          <p-dropdown [filter]="true"
                      [(ngModel)]="componentSettings?.smallPrimaryIconBar.icon3url"
                      [options]="iconOptions"></p-dropdown>
        </ng-template>
        <label for="card3url">Title 3 Card URL</label>
        <input *ngIf="clientData.homePageMainIconsComponent == 'v3';"
               class="full-width"
               pInputText
               #card3url
               id="card3url"
               [(ngModel)]="componentSettings?.smallPrimaryIconBar.card3url" />
        <label for="text3">Text</label>
        <input class="full-width"
               pInputText
               id="text3"
               [(ngModel)]="componentSettings?.smallPrimaryIconBar.text3" />
        <label for="backText3"
               *ngIf="clientData.homePageMainIconsComponent !== 'v3'">Back Text</label>
        <input *ngIf="clientData.homePageMainIconsComponent !== 'v3'"
               class="full-width"
               pInputText
               id="backText3"
               [(ngModel)]="componentSettings?.smallPrimaryIconBar.backText3" />
        <label for="seoTitle3">SEO Title</label>
        <input class="full-width"
               pInputText
               id="seoTitle3"
               [(ngModel)]="componentSettings?.smallPrimaryIconBar.seoTitle3" />
        <label for="alt3">Alt 3</label>
        <input class="full-width"
               pInputText
               id="alt3"
               [(ngModel)]="componentSettings?.smallPrimaryIconBar.alt3" />
      </div>
      <div class="col-md-4">
        <img *ngIf="clientData.homePageMainIconsComponent !== 'svg' && clientData.homePageMainIconsComponent !== 'v3'; else showSvg3"
             [src]="componentSettings.smallPrimaryIconBar.icon3url"
             class="icon-image"
             alt="">
        <ng-template #showSvg3>
          <div [innerHtml]="componentSettings.smallPrimaryIconBar.icon3url | keepHtml"></div>
        </ng-template>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <h5>Separator Bar Component</h5>
        <div class="mb-5">
          <label for="separatorTitle">Title</label>
          <input class="full-width"
                 pInputText
                 id="separatorTitle"
                 [(ngModel)]="componentSettings.separatorBar.title" />
        </div>
        <div class="mb-5">
          <label>Blurb</label>
          <textarea [froalaEditor]="options"
                    [(froalaModel)]="componentSettings.separatorBar.text"
                    class="full-width"></textarea>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="col-md-12">
          <h5>Picture Card Item Component</h5>
        </div>
        <div class="mb-5">
          <label for="pictureCardTitle">Title</label>
          <input class="full-width"
                 pInputText
                 id="pictureCardTitle"
                 [(ngModel)]="componentSettings.pictureCard.title" />
        </div>
        <div class="mb-5">
          <label for="pictureCardButtonText">Button Text</label>
          <input class="full-width"
                 pInputText
                 id="pictureCardButtonText"
                 [(ngModel)]="componentSettings.pictureCard.buttonText" />
        </div>
        <div class="mb-5">
          <label for="pictureCardButtonUrl">Button Link</label>
          <input class="full-width"
                 pInputText
                 id="pictureCardButtonUrl"
                 [(ngModel)]="componentSettings.pictureCard.buttonUrl" />
        </div>
        <app-picture-card (onSave)="saveComponentSettings()"
                          [(cards)]="componentSettings.pictureCard.cardItem"></app-picture-card>
      </div>
    </div>

    <div class="row margin-top">
      <div class="col-md-6">

        <div class="col-md-12">
          <h1>Slideshow Row</h1>
          <div class="mb-5">
            <label for="slideshowRowTitleText">Title</label>
            <input class="full-width"
                   pInputText
                   id="slideshowRowTitleText"
                   [(ngModel)]="componentSettings.slideshowRow.titleText" />
          </div>
          <app-slideshow (onSave)="saveComponentSettings()"
                         [slides]="componentSettings.slideshowRow.sliderUrls"
                         [showSliderArrows]="componentSettings.slideshowRow.showSliderArrows"
                         [sliderAutoPlay]="componentSettings.slideshowRow.sliderAutoPlay"></app-slideshow>
        </div>
        <div class="col-md-12 pt-1">
          <div *ngIf="clientData?.slideshowRowData?.showSideArticle">
            <h5 class="ml-4">Side article</h5>
            <textarea [froalaEditor]="options"
                      [(froalaModel)]="componentSettings.slideshowRow.articleText"
                      class="full-width"></textarea>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <h1>HowTo Row</h1>
        <p>NOTE: All fields are required.</p>
        <div class="row">
          <div class="col-md-2">
            <h3>Title:</h3>
          </div>
          <div class="col-md-10">
            <input [(ngModel)]="componentSettings.howToRow.title"
                   pInputText
                   class="full-width"
                   type="text" />
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <h3>Blurb:</h3>
            <textarea [froalaEditor]="options"
                      [(froalaModel)]="componentSettings.howToRow.blurb"
                      class="full-width"></textarea>
          </div>
        </div>
        <app-howto-row (onSave)="saveComponentSettings()"
                       [(cards)]="componentSettings.howToRow.cards"></app-howto-row>
      </div>
    </div>

    <div class="row margin-top">
      <div class="col-xs-12">
        <h1>Moving Supplies</h1>
        <md-slide-toggle [(ngModel)]="componentSettings.movingSupplies.hide">
          <p> Hide moving supplies</p>
        </md-slide-toggle>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <h5>Moving Supplies Offered</h5>
        <p-dataTable [value]="componentSettings.movingSupplies.itemsOffered"
                     [editable]="true"
                     (onEditComplete)="saveMovingSuppliesItem($event)"
                     [(selection)]="movingSuppliesItem"
                     [responsive]="true"
                     class="text-center">
          <p-header>Moving Supplies Listing</p-header>
          <p-column field="label"
                    header="Label"
                    [editable]="true"></p-column>
          <p-column styleClass="col-button">
            <ng-template let-car="rowData"
                         pTemplate="body">
              <button type="button"
                      pButton
                      (click)="onMovingSuppliesItemRowSelect({data: car})"
                      icon="fa-edit"></button>
            </ng-template>
          </p-column>
          <p-footer>
            <div class="ui-helper-clearfix"
                 style="width:100%">
              <button type="button"
                      class="btn btn-primary"
                      color="primary"
                      style="float:left"
                      (click)="showMovingSuppliesItemToAdd()">
                <i class="fa fa-plus"
                   aria-hidden="true"></i> Add
              </button>
            </div>
          </p-footer>
        </p-dataTable>
      </div>
      <div class="col-md-6">
        <div class="row sm-padding-top">
          <div class="col-md-12">
            <h5>Rent/Reserve a Unit</h5>
          </div>
          <div class="col-md-4">
            <label for="movingSupplies">Moving Supplies Image URL</label>
          </div>
          <div class="col-md-8">
            <input class="full-width"
                   pInputText
                   id="movingSupplies"
                   [(ngModel)]="componentSettings.movingSupplies.imageUrl" />
          </div>
          <div class="col-md-12"><img class="icon-image-moving"
                 [src]="componentSettings.movingSupplies.imageUrl"
                 alt=""></div>
          <div class="col-md-12 sm-padding-top">
            <md-slide-toggle [(ngModel)]="componentSettings.rentReserveUnit.showInsuranceBlurb">Show Blurb on
              Insurance
              Page</md-slide-toggle>
          </div>
          <div *ngIf="componentSettings.rentReserveUnit.showInsuranceBlurb"
               class="col-md-12">
            <label>Insurance Blurb (HTML Allowed)</label>
            <textarea pInputTextarea
                      class="full-width text-area-box"
                      [froalaEditor]="options2"
                      [(froalaModel)]="componentSettings.rentReserveUnit.insuranceBlurb"></textarea>
            <!-- <div *ngIf="locationData.showInsuranceOptions == true" id="insuranceHelpText" [froalaEditor]="options2" [(froalaModel)]="locationData.insuranceHelpText"></div> -->
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <h5>View All Units</h5>
      <div class="col-md-6">
        <md-slide-toggle class="sm-padding-top"
                         [(ngModel)]="componentSettings.viewAllUnits.showUnitDescription"> Show unit description
          tooltip?
        </md-slide-toggle>
        <br>
        <br>
        <md-slide-toggle class="sm-padding-top"
                         [(ngModel)]="componentSettings.viewAllUnits.showUnitDescriptionInsteadOfAmenities"> Show unit
          description instead of amenities?
        </md-slide-toggle>
        <br>
        <br>
        <p><b>Rent a Unit Summary</b></p>
        <textarea pInputTextarea
                  class="full-width text-area-box"
                  [(ngModel)]="componentSettings.viewAllUnits.rentSummary"></textarea>
        <md-slide-toggle [(ngModel)]="componentSettings.viewAllUnits.rentSummaryTitle">Show Rent a Unit Summary Title
        </md-slide-toggle>

        <br>
        <br>
        <p><b>Reserve a Unit Summary</b></p>
        <textarea pInputTextarea
                  class="full-width text-area-box"
                  [(ngModel)]="componentSettings.viewAllUnits.reserveSummary"></textarea>
        <md-slide-toggle [(ngModel)]="componentSettings.viewAllUnits.reserveSummaryTitle">Show Reserve a Unit Summary
          Title</md-slide-toggle>

        <br>
        <br>

        <p><b>Datepicker Holiday Options</b></p>
        <p>"On" means the holiday will be disabled from the Datepicker</p>
        <md-slide-toggle [(ngModel)]="componentSettings?.viewAllUnits?.holidays.newYears">New Year's Day
        </md-slide-toggle>
        <br>
        <md-slide-toggle [(ngModel)]="componentSettings?.viewAllUnits?.holidays.mlk">MLK Jr. Day</md-slide-toggle>
        <br>
        <md-slide-toggle [(ngModel)]="componentSettings?.viewAllUnits?.holidays.washingtonBirthday">Washington's
          Birthday
          Day</md-slide-toggle>
        <br>
        <md-slide-toggle [(ngModel)]="componentSettings?.viewAllUnits?.holidays.armedForces">Armed Forces Day
        </md-slide-toggle>
        <br>
        <md-slide-toggle [(ngModel)]="componentSettings?.viewAllUnits?.holidays.memorial">Memorial Day Day
        </md-slide-toggle>
        <br>
        <md-slide-toggle [(ngModel)]="componentSettings?.viewAllUnits?.holidays.flag">Flag Day</md-slide-toggle>
        <br>
        <md-slide-toggle [(ngModel)]="componentSettings?.viewAllUnits?.holidays.independence">Independencd Day
        </md-slide-toggle>
        <br>
        <md-slide-toggle [(ngModel)]="componentSettings?.viewAllUnits?.holidays.labor">Labor Day</md-slide-toggle>
        <br>
        <md-slide-toggle [(ngModel)]="componentSettings?.viewAllUnits?.holidays.columbus">Columbus Day</md-slide-toggle>
        <br>
        <md-slide-toggle [(ngModel)]="componentSettings?.viewAllUnits?.holidays.veterans">Veteran's Day
        </md-slide-toggle>
        <br>
        <md-slide-toggle [(ngModel)]="componentSettings?.viewAllUnits?.holidays.thanksgiving">Thanksgiving Day
        </md-slide-toggle>
        <br>
        <md-slide-toggle [(ngModel)]="componentSettings?.viewAllUnits?.holidays.christmasEve">Christmas Eve Day
        </md-slide-toggle>
        <br>
        <md-slide-toggle [(ngModel)]="componentSettings?.viewAllUnits?.holidays.christmas">Christmas Day
        </md-slide-toggle>
        <br>
        <md-slide-toggle [(ngModel)]="componentSettings?.viewAllUnits?.holidays.newYearsEve">New Year's Eve Day
        </md-slide-toggle>
        <br>

      </div>
      <div class="col-md-6">
        <div class="row">
          <div class="col-md-12">
            <h5><b>Filters</b></h5>
            <md-slide-toggle [(ngModel)]="componentSettings.viewAllUnits.showFeaturesFilters">Show Features Filters
            </md-slide-toggle>
            <br>
            <md-slide-toggle [(ngModel)]="componentSettings.viewAllUnits.filterUnitsByUnitType">Filter Units by Unit
              Type instead of SM, MD, LG...</md-slide-toggle>
            <hr>
            <md-slide-toggle *ngIf="componentSettings.viewAllUnits.showFeaturesFilters"
                             [(ngModel)]="componentSettings.viewAllUnits.showClimate">Show Climate Controlled Filter
            </md-slide-toggle>
            <br>
            <md-slide-toggle *ngIf="componentSettings.viewAllUnits.showFeaturesFilters"
                             [(ngModel)]="componentSettings.viewAllUnits.showInside">Show Inside Filter
            </md-slide-toggle>
            <br>
            <md-slide-toggle *ngIf="componentSettings.viewAllUnits.showFeaturesFilters"
                             [(ngModel)]="componentSettings.viewAllUnits.showPowerOutlet">Show Power Outlet Filter
            </md-slide-toggle>
            <br>
            <md-slide-toggle *ngIf="componentSettings.viewAllUnits.showFeaturesFilters"
                             [(ngModel)]="componentSettings.viewAllUnits.showUnitAlarm">Show Unit Alarm Filter
            </md-slide-toggle>
            <br>
            <md-slide-toggle *ngIf="componentSettings.viewAllUnits.showFeaturesFilters"
                             [(ngModel)]="componentSettings.viewAllUnits.showGroundFloor">Show Ground Floor Filter
            </md-slide-toggle>
            <br>
            <md-slide-toggle *ngIf="componentSettings.viewAllUnits.showFeaturesFilters"
                             [(ngModel)]="componentSettings.viewAllUnits.useBoatIconForParking">Use Boat Icon for
              Parking
              Instad of "P" (doesn't work for Uhaul)</md-slide-toggle>
            <br>
            <br>
            <div>
              <label for="showAllText">Show All Filter Button Text</label>
              <input pInputText
                     id="showAllText"
                     class="full-width"
                     [(ngModel)]="componentSettings.viewAllUnits.showAllText" />
            </div>

            <div>
              <label for="groundFloor">Ground floor</label>
              <input pInputText
                     id="groundFloor"
                     class="full-width"
                     type="number"
                     [(ngModel)]="componentSettings.viewAllUnits.groundFloor" />
            </div>
            <br>
            <md-slide-toggle [(ngModel)]="componentSettings.viewAllUnits.showSecondFloor">
              Show Stair Access/Second Floor Icon
            </md-slide-toggle>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <md-slide-toggle [(ngModel)]="componentSettings.viewAllUnits.showSizeFilters">
              Show Size Filters
            </md-slide-toggle>
            <hr>
            <p>Size labels</p>
            <p>(Shows up in the button)</p>
            <label for="5x5">up to 5'x5'</label>
            <input class="full-width"
                   pInputText
                   id="5x5"
                   [(ngModel)]="componentSettings.viewAllUnits.filters.walkInCloset" />
            <label for="5x10">up to 5'x10'</label>
            <input class="full-width"
                   pInputText
                   id="5x10"
                   [(ngModel)]="componentSettings.viewAllUnits.filters.midSizeRoom" />
            <label for="10x10">up to 10'x10'</label>
            <input class="full-width"
                   pInputText
                   id="10x10"
                   [(ngModel)]="componentSettings.viewAllUnits.filters.familyRoom" />
            <label for="10x15">up to 10'x15'</label>
            <input class="full-width"
                   pInputText
                   id="10x15"
                   [(ngModel)]="componentSettings.viewAllUnits.filters.threeBedrooms" />
            <label for="10x20">up to 10'x20'</label>
            <input class="full-width"
                   pInputText
                   id="10x20"
                   [(ngModel)]="componentSettings.viewAllUnits.filters.fullHouse" />
            <label for="10x25">up to 10'x25'</label>
            <input class="full-width"
                   pInputText
                   id="10x25"
                   [(ngModel)]="componentSettings.viewAllUnits.filters.largeHouse" />
          </div>
          <div class="col-md-6">
            <br>
            <hr>
            <p>Alternate Size Descriptions</p>
            <p>(Shows up under the button)</p>
            <label for="5x5description">up to 5'x5'</label>
            <input class="full-width"
                   pInputText
                   id="5x5description"
                   [(ngModel)]="componentSettings.viewAllUnits.filters.walkInClosetDescription" />
            <label for="5x10description">up to 5'x10'</label>
            <input class="full-width"
                   pInputText
                   id="5x10description"
                   [(ngModel)]="componentSettings.viewAllUnits.filters.midSizeRoomDescription" />
            <label for="10x10description">up to 10'x10'</label>
            <input class="full-width"
                   pInputText
                   id="10x10description"
                   [(ngModel)]="componentSettings.viewAllUnits.filters.familyRoomDescription" />
            <label for="10x15description">up to 10'x15'</label>
            <input class="full-width"
                   pInputText
                   id="10x15description"
                   [(ngModel)]="componentSettings.viewAllUnits.filters.threeBedroomsDescription" />
            <label for="10x20description">up to 10'x20'</label>
            <input class="full-width"
                   pInputText
                   id="10x20description"
                   [(ngModel)]="componentSettings.viewAllUnits.filters.fullHouseDescription" />
            <label for="10x25description">up to 10'x25'</label>
            <input class="full-width"
                   pInputText
                   id="10x25description"
                   [(ngModel)]="componentSettings.viewAllUnits.filters.largeHouseDescription" />
          </div>
        </div>
        <div>
          <p>Buttons</p>
          <p>
            <md-slide-toggle [(ngModel)]="componentSettings.viewAllUnits.show5x5">Show 5x5 Filter</md-slide-toggle>
          </p>
          <p>
            <md-slide-toggle [(ngModel)]="componentSettings.viewAllUnits.show5x10">Show 5x10 Filter</md-slide-toggle>
          </p>
          <p>
            <md-slide-toggle [(ngModel)]="componentSettings.viewAllUnits.show10x10">Show 10x10 Filter
            </md-slide-toggle>
          </p>
          <p>
            <md-slide-toggle [(ngModel)]="componentSettings.viewAllUnits.show10x15">Show 10x15 Filter
            </md-slide-toggle>
          </p>
          <p>
            <md-slide-toggle [(ngModel)]="componentSettings.viewAllUnits.show10x20">Show 10x20 Filter
            </md-slide-toggle>
          </p>
          <p>
            <md-slide-toggle [(ngModel)]="componentSettings.viewAllUnits.show10x25">Show 10x25 Filter
            </md-slide-toggle>
          </p>
        </div>
      </div>
    </div>

    <p-dialog header="Moving Supplies Item"
              [(visible)]="displayMovingSuppliesItemDialog"
              [responsive]="true"
              showEffect="fade"
              [modal]="true"
              [positionTop]="100"
              [dismissableMask]="true">
      <div class="ui-grid ui-grid-responsive ui-fluid"
           *ngIf="movingSuppliesItem">
        <div class="ui-grid-row sm-padding-top">
          <div class="ui-grid-col-4">
            <label for="label">Label</label>
          </div>
          <div class="ui-grid-col-8">
            <input pInputText
                   id="label"
                   [(ngModel)]="movingSuppliesItem.label" />
          </div>
        </div>
      </div>
      <p-footer>
        <div class="ui-dialog-buttonpane ui-helper-clearfix">
          <button class="btn btn-default"
                  *ngIf="!newMovingSuppliesItem"
                  style="float:left"
                  (click)="deleteMovingSuppliesItem(movingSuppliesItem.label)"><i class="fa fa-close"
               aria-hidden="true"></i> Delete</button>
          <button class="btn btn-primary"
                  color="primary"
                  (click)="saveMovingSuppliesItem()"><i class="fa fa-check"
               aria-hidden="true"></i> Save</button>
        </div>
      </p-footer>
    </p-dialog>

    <div class="row">
      <div class="col-md-6">
        <h5>Footer</h5>
        <label for="footer-blurb-title">Blurb Title</label>
        <input class="full-width"
               pInputText
               id="footer-blurb-title"
               [(ngModel)]="componentSettings?.footer.blurbTitle" />
        <label for="footer-blurb">Blurb</label>
        <textarea [froalaEditor]="options"
                  [(froalaModel)]="componentSettings?.footer.blurb"
                  id="footer-blurb"
                  class="full-width"></textarea>


        <div class="row">
          <div class="col-xs-12">
            <h4>Small Footer Links</h4>
            <h5>No More Than Four!</h5>
            <div>
              <div *ngFor="let link of componentSettings.smallFooterLinks; let index = index">

                <input pInputText
                       style="display:inline-block;margin-top:15px;width:37.5%"
                       placeholder="Link URL"
                       [(ngModel)]="componentSettings.smallFooterLinks[index].url" />
                <input pInputText
                       style="display:inline-block;margin-top:15px;width:37.5%"
                       placeholder="Link name"
                       [(ngModel)]="componentSettings.smallFooterLinks[index].name" />
              </div>
              <button type="button"
                      class="btn btn-accent"
                      color="accent"
                      style="margin-top:15px;"
                      (click)="componentSettings.smallFooterLinks.push({url: null, name: null})">Add Link</button>
              <button type="button"
                      class="btn btn-primary"
                      color="primary"
                      style="margin-top:15px;"
                      (click)="saveComponentSettings();">Save Links</button>
            </div>
          </div>
        </div>

      </div>
      <div class="col-md-6">
        <h5>Homepage Recent Blog Banner</h5>
        <md-slide-toggle [(ngModel)]="componentSettings?.homePageBlogBanner.useMetaForSummary">
          Use Meta Description for summary instead of first 50 words
        </md-slide-toggle>
        <br>
        <label for="homepage-blog-title">Blurb Title</label>
        <input class="full-width"
               pInputText
               id="homepage-blog-title"
               [(ngModel)]="componentSettings?.homePageBlogBanner.title" />
        <label for="homepage-blog-blurb">Blurb</label>
        <textarea [froalaEditor]="options"
                  [(froalaModel)]="componentSettings?.homePageBlogBanner.blurb"
                  id="homepage-blog-blurb"
                  class="full-width"></textarea>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <h5>Locations Near You Banner</h5>
        <label for="lnu-blurb-title">Blurb Title</label>
        <input class="full-width"
               pInputText
               id="lnu-blurb-title"
               [(ngModel)]="componentSettings?.locationsNearYou.blurbTitle" />
        <label for="lnu-blurb">Blurb</label>
        <textarea [froalaEditor]="options"
                  [(froalaModel)]="componentSettings?.locationsNearYou.blurb"
                  id="lnu-blurb"
                  class="full-width"></textarea>
      </div>
      <div class="col-md-6">
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <h5 style="display:inline-block;margin-right:25px;">Facility Info Banner</h5>
      </div>
      <div class="col-md-6">
        <label for="facility-info-banner-title">{{clientData?.facilityInfoBannerComponent === 'version2' ? 'Left Top ' :
          ''}}Title</label>
        <input class="full-width"
               pInputText
               id="facility-info-banner-title"
               [(ngModel)]="componentSettings?.facilityInfoBanner.title" />
        <ng-container *ngIf="clientData?.facilityInfoBannerComponent === 'version2'">
          <label for="facility-info-banner-left-bottom-title">Left Bottom Title</label>
          <input class="full-width"
                 pInputText
                 id="facility-info-banner-left-bottom-title"
                 [(ngModel)]="componentSettings?.facilityInfoBanner.leftBottomTitle" />
          <label for="facility-info-banner-right-top-title">Right Top Title</label>
          <input class="full-width"
                 pInputText
                 id="facility-info-banner-right-top-title"
                 [(ngModel)]="componentSettings?.facilityInfoBanner.rightTopTitle" />
        </ng-container>
        <ng-container *ngIf="clientData?.facilityInfoBannerComponent !== 'version2'">
          <label for="facility-info-banner-image-url">Image Url</label>
          <input class="full-width"
                 pInputText
                 id="facility-info-banner-image-url"
                 [(ngModel)]="componentSettings?.facilityInfoBanner.imageUrl" />
          <label for="facility-info-banner-cta-text">CTA Text</label>
          <input class="full-width"
                 pInputText
                 id="facility-info-banner-cta-text"
                 [(ngModel)]="componentSettings?.facilityInfoBanner.ctaText" />
          <label for="facility-info-banner-cta-link">CTA Link</label>
          <input class="full-width"
                 pInputText
                 id="facility-info-banner-cta-text"
                 [(ngModel)]="componentSettings?.facilityInfoBanner.ctaLink" />
        </ng-container>
      </div>
      <div class="col-md-6">
        <label for="facility-info-banner-body">Body</label>
        <!-- <div id="storageTip-body" [froalaEditor]="options" [(froalaModel)]="model.body"></div> -->

        <textarea [froalaEditor]="options"
                  [(froalaModel)]="componentSettings?.facilityInfoBanner.body "
                  id="facility-info-banner-body "
                  class="full-width "></textarea>

      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <h2 style="display:inline-block; margin-bottom:25px;">HTML Row(s)</h2>
        <div [dragula]="'html-rows-bag'"
             [dragulaModel]="componentSettings.htmlRows">
          <div class="mb-3"
               *ngFor="let row of componentSettings.htmlRows; let index = index">
            <h5>HTML Row {{index + 1}}</h5>
            <div class="row">
              <div class="col-md-11">
                <textarea [froalaEditor]="options"
                          [(froalaModel)]="row.html"
                          id="html-row-{{index}}"
                          class="full-width"></textarea>
              </div>
              <button type="button"
                      class="btn btn-danger col-md-1"
                      (click)="deleteHTMLRow(index)">X</button>
            </div>
          </div>
        </div>
        <div class="ui-helper-clearfix row mt-3"
             style="width:100%">
          <div class="col-md-4">
            <button type="button"
                    class="btn btn-primary"
                    color="primary"
                    style="float:left; max-width: 75px;"
                    (click)="showHTMLRowsToAdd()">
              <i class="fa fa-plus"
                 aria-hidden="true"></i> Add
            </button>
          </div>
          <div class="col-md-4">
            <button type="button"
                    class="btn btn-primary"
                    color="primary"
                    style="max-width: 125px;"
                    (click)="saveComponentSettings();">Save Rows</button>
          </div>
        </div>
      </div>
    </div>


    <div class="row">
      <div class="col-md-12">
        <h5 style="display:inline-block;margin-right:25px;">Homepage Links Card</h5>
        <a href="https://material.io/tools/icons/?icon=insert_emoticon&style=baseline"
           target="_blank">icons</a>
      </div>
      <div class="col-xs-12">
        <div class="row">
          <div class="col-sm-4">
            <h3>Link 0</h3>
            <div>
              <label for="homepage-links-card-icon-0">Material Icon Class <i class="material-icons">{{
                  componentSettings?.homepageLinksCardLinks[0].iconClass }}</i></label>
              <input class="full-width"
                     pInputText
                     id="homepage-links-card-icon-0"
                     [(ngModel)]="componentSettings?.homepageLinksCardLinks[0].iconClass" />
            </div>
            <div>
              <label for="homepage-links-card-link-0">Link</label>
              <input class="full-width"
                     pInputText
                     id="homepage-links-card-link-0"
                     [(ngModel)]="componentSettings?.homepageLinksCardLinks[0].link" />
            </div>
            <div>
              <md-slide-toggle [(ngModel)]="componentSettings?.homepageLinksCardLinks[0].isExternal">
                Link is external
              </md-slide-toggle>
            </div>
            <div>
              <label for="homepage-links-card-title-0">Title</label>
              <input class="full-width"
                     pInputText
                     id="homepage-links-card-title-0"
                     [(ngModel)]="componentSettings?.homepageLinksCardLinks[0].title" />
            </div>
            <div>
              <label for="homepage-links-card-subtitle-0">Subtitle</label>
              <input class="full-width"
                     pInputText
                     id="homepage-links-card-subtitle-0"
                     [(ngModel)]="componentSettings?.homepageLinksCardLinks[0].subtitle" />
            </div>
          </div>
          <div class="col-sm-4">
            <h3>Link 1</h3>
            <div>
              <label for="homepage-links-card-icon-1">Material Icon Class <i class="material-icons">{{
                  componentSettings?.homepageLinksCardLinks[1].iconClass }}</i></label>
              <input class="full-width"
                     pInputText
                     id="homepage-links-card-icon-1"
                     [(ngModel)]="componentSettings?.homepageLinksCardLinks[1].iconClass" />
            </div>
            <div>
              <label for="homepage-links-card-link-1">Link</label>
              <input class="full-width"
                     pInputText
                     id="homepage-links-card-link-1"
                     [(ngModel)]="componentSettings?.homepageLinksCardLinks[1].link" />
            </div>
            <div>
              <md-slide-toggle [(ngModel)]="componentSettings?.homepageLinksCardLinks[1].isExternal">
                Link is external
              </md-slide-toggle>
            </div>
            <div>
              <label for="homepage-links-card-title-1">Title</label>
              <input class="full-width"
                     pInputText
                     id="homepage-links-card-title-1"
                     [(ngModel)]="componentSettings?.homepageLinksCardLinks[1].title" />
            </div>
            <div>
              <label for="homepage-links-card-subtitle-1">Subtitle</label>
              <input class="full-width"
                     pInputText
                     id="homepage-links-card-subtitle-1"
                     [(ngModel)]="componentSettings?.homepageLinksCardLinks[1].subtitle" />
            </div>
          </div>
          <div class="col-sm-4">
            <h3>Link 2</h3>
            <div>
              <label for="homepage-links-card-icon-2">Material Icon Class <i class="material-icons">{{
                  componentSettings?.homepageLinksCardLinks[2].iconClass }}</i></label>
              <input class="full-width"
                     pInputText
                     id="homepage-links-card-icon-2"
                     [(ngModel)]="componentSettings?.homepageLinksCardLinks[2].iconClass" />
            </div>
            <div>
              <label for="homepage-links-card-link-2">Link</label>
              <input class="full-width"
                     pInputText
                     id="homepage-links-card-link-2"
                     [(ngModel)]="componentSettings?.homepageLinksCardLinks[2].link" />
            </div>
            <div>
              <md-slide-toggle [(ngModel)]="componentSettings?.homepageLinksCardLinks[2].isExternal">
                Link is external
              </md-slide-toggle>
            </div>
            <div>
              <label for="homepage-links-card-title-2">Title</label>
              <input class="full-width"
                     pInputText
                     id="homepage-links-card-title-2"
                     [(ngModel)]="componentSettings?.homepageLinksCardLinks[2].title" />
            </div>
            <div>
              <label for="homepage-links-card-subtitle-2">Subtitle</label>
              <input class="full-width"
                     pInputText
                     id="homepage-links-card-subtitle-2"
                     [(ngModel)]="componentSettings?.homepageLinksCardLinks[2].subtitle" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-4">
            <h3>Link 3</h3>
            <div>
              <label for="homepage-links-card-icon-3">Material Icon Class <i class="material-icons">{{
                  componentSettings?.homepageLinksCardLinks[3].iconClass }}</i></label>
              <input class="full-width"
                     pInputText
                     id="homepage-links-card-icon-3"
                     [(ngModel)]="componentSettings?.homepageLinksCardLinks[3].iconClass" />
            </div>
            <div>
              <label for="homepage-links-card-link-3">Link</label>
              <input class="full-width"
                     pInputText
                     id="homepage-links-card-link-3"
                     [(ngModel)]="componentSettings?.homepageLinksCardLinks[3].link" />
            </div>
            <div>
              <md-slide-toggle [(ngModel)]="componentSettings?.homepageLinksCardLinks[3].isExternal">
                Link is external
              </md-slide-toggle>
            </div>
            <div>
              <label for="homepage-links-card-title-3">Title</label>
              <input class="full-width"
                     pInputText
                     id="homepage-links-card-title-3"
                     [(ngModel)]="componentSettings?.homepageLinksCardLinks[3].title" />
            </div>
            <div>
              <label for="homepage-links-card-subtitle-3">Subtitle</label>
              <input class="full-width"
                     pInputText
                     id="homepage-links-card-subtitle-3"
                     [(ngModel)]="componentSettings?.homepageLinksCardLinks[3].subtitle" />
            </div>
          </div>
          <div class="col-sm-4">
            <h3>Link 4</h3>
            <div>
              <label for="homepage-links-card-icon-4">Material Icon Class <i class="material-icons">{{
                  componentSettings?.homepageLinksCardLinks[4].iconClass }}</i></label>
              <input class="full-width"
                     pInputText
                     id="homepage-links-card-icon-4"
                     [(ngModel)]="componentSettings?.homepageLinksCardLinks[4].iconClass" />
            </div>
            <div>
              <label for="homepage-links-card-link-4">Link</label>
              <input class="full-width"
                     pInputText
                     id="homepage-links-card-link-4"
                     [(ngModel)]="componentSettings?.homepageLinksCardLinks[4].link" />
            </div>
            <div>
              <md-slide-toggle [(ngModel)]="componentSettings?.homepageLinksCardLinks[4].isExternal">
                Link is external
              </md-slide-toggle>
            </div>
            <div>
              <label for="homepage-links-card-title-4">Title</label>
              <input class="full-width"
                     pInputText
                     id="homepage-links-card-title-4"
                     [(ngModel)]="componentSettings?.homepageLinksCardLinks[4].title" />
            </div>
            <div>
              <label for="homepage-links-card-subtitle-4">Subtitle</label>
              <input class="full-width"
                     pInputText
                     id="homepage-links-card-subtitle-4"
                     [(ngModel)]="componentSettings?.homepageLinksCardLinks[4].subtitle" />
            </div>
          </div>
          <div class="col-sm-4">
            <h3>Link 5</h3>
            <div>
              <label for="homepage-links-card-icon-5">Material Icon Class <i class="material-icons">{{
                  componentSettings?.homepageLinksCardLinks[5].iconClass }}</i></label>
              <input class="full-width"
                     pInputText
                     id="homepage-links-card-icon-5"
                     [(ngModel)]="componentSettings?.homepageLinksCardLinks[5].iconClass" />
            </div>
            <div>
              <label for="homepage-links-card-link-5">Link</label>
              <input class="full-width"
                     pInputText
                     id="homepage-links-card-link-5"
                     [(ngModel)]="componentSettings?.homepageLinksCardLinks[5].link" />
            </div>
            <div>
              <md-slide-toggle [(ngModel)]="componentSettings?.homepageLinksCardLinks[5].isExternal">
                Link is external
              </md-slide-toggle>
            </div>
            <div>
              <label for="homepage-links-card-title-5">Title</label>
              <input class="full-width"
                     pInputText
                     id="homepage-links-card-title-5"
                     [(ngModel)]="componentSettings?.homepageLinksCardLinks[5].title" />
            </div>
            <div>
              <label for="homepage-links-card-subtitle-5">Subtitle</label>
              <input class="full-width"
                     pInputText
                     id="homepage-links-card-subtitle-5"
                     [(ngModel)]="componentSettings?.homepageLinksCardLinks[5].subtitle" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <h5 style="display:inline-block;margin-right:25px;">Google Maps/Store Locator</h5>
        <button class="btn btn-primary"
                color="primary"
                (click)="displayGenerateMarkersDialog = true">Generate Markers</button>

        <p> 1. google the facility and look at the maps page to get latitude/longitude then input the settings needed
          <br>2. get an icon and add that URL (probably from firebase after you upload it)
          <br>3. go to the style maker and get the style JSON at <a href="https://mapstyle.withgoogle.com/"
             target="_blank">https://mapstyle.withgoogle.com)</a> and paste into the map.styles setting
          <br>4. (optional) use customer's google maps API key in app.module.ts
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <p>Placement - Contact Page Only</p>
        <p-dropdown [options]="mapPlacement"
                    [(ngModel)]="componentSettings?.maps.placement"></p-dropdown>
      </div>
      <div class="col-md-4">
        <p>Latitude</p>
        <input class="full-width"
               type="number"
               pInputText
               id="lat"
               [(ngModel)]="componentSettings?.maps.latitude" />
      </div>
      <div class="col-md-4">
        <p>Longitude</p>
        <input class="full-width"
               type="number"
               pInputText
               id="long"
               [(ngModel)]="componentSettings?.maps.longitude" />
      </div>
    </div>
    <div class="row margin-bottom">
      <div class="col-md-4">
        <p>Zoom</p>
        <input class="full-width"
               type="number"
               pInputText
               id="zoom"
               [(ngModel)]="componentSettings?.maps.zoom" />
      </div>
      <div class="col-md-8">
        <br>
        <br>
        <textarea pInputTextarea
                  [(ngModel)]="componentSettings?.maps.styles"
                  id="mapStyles"
                  cols="30"
                  rows="10"></textarea>
        <p>Styles (Copy and paste from <a href="https://mapstyle.withgoogle.com/"
             target="_blank">https://mapstyle.withgoogle.com)</a> or here <a href="https://snazzymaps.com/"
             target="_blank">https://snazzymaps.com/</a></p>

      </div>
    </div>

    <div class="row margin-bottom">
      <div class="col-md-12">
        <p-dataTable [value]="componentSettings?.maps?.markers"
                     selectionMode="single"
                     [(selection)]="selectedMapMarker"
                     (onRowSelect)="onMapMarkerRowSelect($event)"
                     [responsive]="true"
                     [immutable]="false"
                     class="text-center">
          <p-header>Map Markers</p-header>
          <p-column field="title"
                    header="Title"></p-column>
          <p-column field="customIconUrl"
                    header="Custom Icon URL">
            <ng-template let-col
                         let-car="rowData"
                         pTemplate="body">
              <span><img class="facility-logo"
                     [src]="car[col.field]"
                     alt=""></span>
            </ng-template>
          </p-column>
          <p-column field="latitude"
                    header="Latitude"></p-column>
          <p-column field="longitude"
                    header="Longitude"></p-column>
          <p-column field="useCustomInfoWindow"
                    header="Use Custom Info Window"></p-column>
          <p-column field="infoWindowMaxWidth"
                    header="Info Window Max Width"></p-column>
          <p-footer>
            <div class="ui-helper-clearfix"
                 style="width:100%">
              <button type="button"
                      class="btn btn-primary"
                      color="primary"
                      style="float:left"
                      (click)="showMapMarkerToAdd()">
                <i class="fa fa-plus"
                   aria-hidden="true"></i> Add
              </button>
            </div>
          </p-footer>
        </p-dataTable>
      </div>
    </div>

    <p-dialog header="Map Marker Controls"
              [(visible)]="displayMapMarkerDialog"
              [responsive]="true"
              showEffect="fade"
              [modal]="true"
              [positionTop]="100"
              [dismissableMask]="true">
      <div class="ui-grid ui-grid-responsive ui-fluid"
           *ngIf="mapMarker">
        <div class="ui-grid-row sm-padding-top">
          <div class="ui-grid-col-4">
            <label for="title">Location to Prefill</label>
          </div>
          <div class="ui-grid-col-8">
            <p-dropdown [filter]="true"
                        (onChange)="prefillMapMarker($event)"
                        [options]="mapOptions"></p-dropdown>
          </div>
        </div>
        <div class="ui-grid-row sm-padding-top">
          <div class="ui-grid-col-4">
            <label for="title">Title</label>
          </div>
          <div class="ui-grid-col-8">
            <input pInputText
                   id="title"
                   [(ngModel)]="mapMarker.title" />
          </div>
        </div>
        <div class="ui-grid-row sm-padding-top">
          <div class="ui-grid-col-4">
            <label for="markerLocationKey">Location Key</label>
          </div>
          <div class="ui-grid-col-8">
            <input pInputText
                   id="markerLocationKey"
                   [(ngModel)]="mapMarker.locationKey" />
          </div>
        </div>
        <div class="ui-grid-row sm-padding-top">
          <div class="ui-grid-col-4">
            <label for="customIconUrl">Icon URL</label>
          </div>
          <div class="ui-grid-col-8">
            <input pInputText
                   id="customIconUrl"
                   [(ngModel)]="mapMarker.customIconUrl" />
          </div>
        </div>
        <div class="ui-grid-row sm-padding-top">
          <div class="ui-grid-col-4">
            <label for="latitude">Latitude</label>
          </div>
          <div class="ui-grid-col-8">
            <input type="number"
                   pInputText
                   id="latitude"
                   [(ngModel)]="mapMarker.latitude" />
          </div>
        </div>
        <div class="ui-grid-row sm-padding-top">
          <div class="ui-grid-col-4">
            <label for="longitude">Longitude</label>
          </div>
          <div class="ui-grid-col-8">
            <input type="number"
                   pInputText
                   id="longitude"
                   [(ngModel)]="mapMarker.longitude" />
          </div>
        </div>
        <div class="ui-grid-row sm-padding-top">
          <div class="ui-grid-col-4">
            <label for="useCustomInfoWindow">Use Custom Info Window</label>
          </div>
          <div class="ui-grid-col-8">
            <md-slide-toggle id="useCustomInfoWindow"
                             [(ngModel)]="mapMarker.useCustomInfoWindow"></md-slide-toggle>
          </div>
        </div>
        <div class="ui-grid-row sm-padding-top">
          <div class="ui-grid-col-4">
            <label for="infoWindowMaxWidth">Info Window Max Width</label>
          </div>
          <div class="ui-grid-col-8">
            <input pInputText
                   id="infoWindowMaxWidth"
                   [(ngModel)]="mapMarker.infoWindowMaxWidth" />
          </div>
        </div>
        <div class="ui-grid-row sm-padding-top">
          <div class="ui-grid-col-4">
            <label for="body">Info Window Body (HTML)</label>
          </div>
          <div class="ui-grid-col-8">
            <textarea pInputTextarea
                      id="body"
                      rows="5"
                      cols="30"
                      [(ngModel)]="mapMarker.body"></textarea>
          </div>
        </div>
      </div>
      <p-footer>
        <div class="ui-dialog-buttonpane ui-helper-clearfix">
          <button class="btn btn-default"
                  *ngIf="!newMapMarker"
                  style="float:left"
                  (click)="deleteMapMarker()"><i class="fa fa-close"
               aria-hidden="true"></i> Delete</button>
          <button class="btn btn-primary"
                  color="primary"
                  (click)="saveMapMarker()"><i class="fa fa-check"
               aria-hidden="true"></i> Save</button>
        </div>
      </p-footer>
    </p-dialog>

    <p-dialog header="Default Map Icon Url"
              [(visible)]="displayGenerateMarkersDialog"
              [responsive]="true"
              showEffect="fade"
              [modal]="true"
              [positionTop]="100"
              [dismissableMask]="true">
      <div class="ui-grid ui-grid-responsive ui-fluid">
        <div class="ui-grid-row sm-padding-top">
          <div class="ui-grid-col-4">
            <label for="markersIconUrl">URL for all icons (optional):</label>
          </div>
          <div class="ui-grid-col-8">
            <input #markersIconUrl
                   pInputText
                   id="markersIconUrl" />
          </div>
        </div>
        <div class="ui-grid-row sm-padding-top">
          <div class="ui-grid-col-4">
            <label for="markersCTAText">CTA above phone number (optional):</label>
          </div>
          <div class="ui-grid-col-8">
            <input #markersCTAText
                   pInputText
                   id="markersCTAText" />
          </div>
        </div>
      </div>
      <p-footer>
        <div class="ui-dialog-buttonpane ui-helper-clearfix">
          <button class="btn btn-primary"
                  color="primary"
                  (click)="generateMapMarkers(markersIconUrl.value, markersCTAText.value)">Continue</button>
        </div>
      </p-footer>
    </p-dialog>

    <div class="row sm-padding-top">
      <div class="col-md-12">
        <h5>Homepage Find Us Blurb</h5>
        <hr>
      </div>
      <div class="col-md-12">
        <textarea [froalaEditor]="options"
                  [(froalaModel)]="componentSettings?.maps.blurb"
                  class="full-width"></textarea>
      </div>
    </div>

    <div class="row padding-top">
      <div class="col-md-12">
        <button class="btn btn-lg btn-secondary"
                color="accent"
                (click)="saveComponentSettings()"
                style="float: right;">Update</button>
      </div>
    </div>
  </md-card>
</div>

<ng-template #loading>
  <div class="spinner">
    <md-spinner color="accent"></md-spinner>
  </div>
</ng-template>



// WEBPACK FOOTER //
// ./src/ng2/app/admin-portal/component-data-settings/component-data-settings.component.html